<template>
<div>
    <div class="top-onetime-area">
        <p class="top-onetime-ttl">{{ $t('otp_input') }}</p>
        <p class="mb30">{{ $t('help_otp.confirm_and_enter_otp_by_app') }}</p>
        <form @submit.prevent="onSubmit()" method="post">
            <div class="top-onetime-inner clearfix">
                <div class="onetime-form-area">
                    <div class="onetime-form-inner">
                        <input 
                            type="text"
                            placeholder="" 
                            v-model="otpCode" 
                            :class="[$v.otpCode.$error || errorMsg ? 'input-error' : '']" class="mb10" 
                            @keypress="isNumber"
                        >
                        <div v-if="submitted && $v.otpCode.$error">
                            <p class="text-error" v-if="!$v.otpCode.required">{{ $t('no_otp_entered') }}</p>
                            <p class="text-error" v-if="!$v.otpCode.integer || !$v.otpCode.minLength || !$v.otpCode.maxLength">{{ $t('the_otp_is_incorrect') }}</p>
                        </div>
                        <p class="text-error" v-if="errorMsg && !$v.otpCode.$error">{{ errorMsg }}</p>

                        <div class="onetime-faq-area clearfix">
                            <a href="javascript:;" @click="$bvModal.show('modal-onetime')" class="modal-syncer" data-target="modal-onetime"><div class="onetime-faq-btn">?</div></a>
                            <p class="onetime-faq-txt"><a href="javascript:;" @click="$bvModal.show('modal-onetime')" class="modal-syncer" data-target="modal-onetime">{{ $t('help_otp.how_to_use_app') }}</a></p>
                        </div>
                    </div>
                </div>
                <div class="onetime-ttl-area">
                    <p class="onetime-icon-password">{{ $t('one_time_pass') }}</p>
                </div>
                <div class="onetime-btn-area">
                    <div class="onetime-btn-base"><a href="javascript:;" @click="onSubmit()"><p>{{ $t('confirm') }}</p></a></div>
                </div>
            </div>
        </form>
    </div>
    <b-modal id="otp-modal" centered :hide-header="true" :hide-footer="true" @hidden="hide">
        <div class="modal-inner" v-if="otpLoading">
            <p class="modal-ttl">{{ $t('waiting_for_otp_aproval') }}</p>
            <p class="center">{{ $t('if_the_screen_does_not_switch_press_reload') }}</p>
            <div class="loading-img">
                <div class="loader">{{ $t('loading') }}</div>
            </div>
            <div class="modal-btn-area clearfix">
            <p class="text-error" v-if="isShowErrorMsg && statusOTP === null">{{ $t('waiting_for_user_approval') }}</p>
            <div class="btn-base pos-left"><a href="javascript:;" @click="onCheckStatusOTP(false)"><p>{{ $t('reload') }}</p></a></div>
            <div class="btn-cancel pos-right"><a href="javascript:;"
                class="modal-close" @click="onCancel()"><p>{{ $t('cancel') }}</p></a></div>
            </div>
        </div>
    </b-modal>
    <b-modal id="patient-allowed" centered :hide-header="true" :hide-footer="true" @hidden="hide">
      <div class="modal-inner">
        <p class="center mb20">{{ $t('this_patient_is_allowed_to_view_without_a_otp') }}</p>
        <div class="modal-btn-area clearfix">
          <div class="btn-base pos-center"><a href="javascript:;" @click="goToPatientInfo()" class="modal-close"><p>{{ $t('ok') }}</p></a></div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-onetime" class="modal-content modal-content-onetime" centered :hide-header="true" :hide-footer="true">
        <div class="modal-onetime-inner modal-inner">
            <p class="modal-onetime-ttl">{{ $t('help_otp.procedure_for_issuing_otp') }}</p>
            <div class="modal-onetime-content mb40 clearfix">
            <div class="onetime-inner-pos01">
                <p class="step-txt">{{ $t('step_1') }}</p>
                <p class="step-ex-txt">
                    {{ $t('help_otp.step_1') }}
                </p>
                <p><img :src="$t('image.otp.step.1')" alt=""></p>
            </div>

            <div class="onetime-inner-pos01">
                <p class="step-txt">{{ $t('step_2') }}</p>
                <p class="step-ex-txt">
                    {{ $t('help_otp.step_2') }}
                </p>
                <p><img :src="$t('image.otp.step.2')" alt=""></p>
            </div>

            <div class="onetime-inner-pos02">
                <p class="step-txt">{{ $t('step_3') }}</p>
                <p class="step-ex-txt">
                    {{ $t('help_otp.step_3') }}
                </p>
                <p class="center"><img :src="$t('image.otp.step.3')" alt=""></p>
            </div>

            <div class="onetime-inner-pos03">
                <p class="step-txt">{{ $t('step_4') }}</p>
                <p class="step-ex-txt">
                    {{ $t('help_otp.step_4') }}
                </p>
                <p><img :src="$t('image.otp.step.4')" alt=""></p>
            </div>
            </div>
            <div class="modal-onetime-btn-area clearfix">
                <div class="btn-onetime-base"><a href="#"  @click="$bvModal.hide('modal-onetime')" class="modal-close"><p>{{ $t('ok') }}</p></a></div>
            </div>
        </div>
    </b-modal>
    <ErrorDialog :content="$t('the_use_of_otp_was_not_permitted')"/>
    <template v-if="$store.state.auth.typeOfUser === 'doctor'">
        <SurveyBanner propStyle="margin: 40px 0;"/>
    </template>
</div>
</template>

<script>
import { BModal, VBModal, BButton } from 'bootstrap-vue'
import { required, integer, minLength, maxLength } from "vuelidate/lib/validators"
import moment from 'moment'
import ErrorDialog from '@/js/components/Common/ErrorDialog'
import SurveyBanner from '@/js/components/Common/SurveyBanner'
import { Strings } from "@/js/commons/strings"
import { mapState } from 'vuex'

export default {
    components: { BModal, BButton, ErrorDialog, SurveyBanner },
    directives: { BModal, VBModal, BButton },
    data() {
        return {
            otpCode: null,
            isShowErrorMsg: false,
            Strings,
            submitted: false,
            timer: '',
        }
    },
    validations: {
        otpCode: {
            required,
            integer,
            minLength: minLength(6),
            maxLength: maxLength(6)
        }
    },
    computed: {
        ...mapState({
            otpLoading: state => state.otp.otpLoading,
			errorMsg: state => state.otp.errorMsg,
            fcmToken: state => state.auth.fcmToken,
            statusOTP: state => state.otp.statusOTP,
            isAllowed: state => state.otp.isAllowed
        })
    },
    methods: {
        isNumber(evt) {
            evt = evt ? evt : window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if(charCode === 13) {
                this.onSubmit()
            }
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else if(isNaN(evt.key)){
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async onSubmit() {
            this.submitted = true
            this.error = ''
            let self = this
            this.$v.otpCode.$touch()
            if (!self.$v.otpCode.$error) {

                await this.$store.dispatch('otp/inputOtp', {
                    otp: this.otpCode,
                    device_token: this.fcmToken
                })

                if (this.isAllowed) {
                    if (!this.errorMsg) {
                        this.$bvModal.hide('otp-modal')
                        this.$bvModal.show('patient-allowed')
                    }
                } else {
                    if (this.otpLoading) {
                        this.$store.dispatch('patient/resetPatientInfo')
                    }

                    if (!this.fcmToken) {
                        if (this.otpLoading) {
                            this.timer = setInterval(this.onCheckStatusOTP, 5000)
                        } else {
                            clearInterval(this.timer)
                        }
                    }
                }

            }
        },
        hide() {
            this.resetForm()
            this.$bvModal.hide('otp-modal')
            this.$store.dispatch("otp/setErrorMsg","")
            this.isShowErrorMsg = this.submitted = false
            if (this.$router.currentRoute.path !== '/' && this.otpLoading) this.$router.push('/')
        },
        goToPatientInfo() {
            this.$bvModal.hide('patient-allowed')
            if (this.$store.state.auth.doctorInfo.patient_histories_flg === 1) {
                this.$router.push('/patient/' + this.$store.state.otp.childId)
            } else {
                var currentPath = this.$router.currentRoute.path
                if (currentPath === '/patient') {
                    location.reload()
                } else {
                    this.$router.push('/patient')
                }
            }
        },
        resetForm() {
            this.otpCode = this.error = null
            this.$v.$reset()
        },
        async onCheckStatusOTP(isAutoCheck = true) {
            const params = {
                one_time_password: this.$store.state.otp.otpCode,
                dr_user_id: this.$store.state.auth.doctorInfo.id,
            }
            await this.$store.dispatch('otp/getStatusOTP', { params: params })

            if (this.statusOTP === 1) {
                if (!this.fcmToken) clearInterval(this.timer)
                this.$bvModal.hide('otp-modal')
                if (this.$store.state.auth.doctorInfo.patient_histories_flg === 1) this.$router.push('/patient/' + this.$store.state.otp.childId)
                else {
                    var currentPath = this.$router.currentRoute.path
                    if (currentPath === '/patient') {
                        location.reload()
                    } else {
                        this.$router.push('/patient')
                    }
                }
            } else if (this.statusOTP === 0) {
                if (!this.fcmToken) clearInterval(this.timer)
                this.$bvModal.hide('otp-modal')
                this.$bvModal.show('modal-error')
            } else {
                if (!isAutoCheck) this.isShowErrorMsg = true
            }
        },
        async onCancel() {
            const params = {
                otp: this.$store.state.otp.otpCode,
                dr_user_id: this.$store.state.auth.doctorInfo.id,
            }
            await this.$store.dispatch('otp/cancelOTP', params)
            if (!this.fcmToken) {
                var highestIntervalId = setInterval(";")
                for (var i = 0 ; i < highestIntervalId ; i += 1) {
                    clearInterval(i)
                }
            }
            this.$bvModal.hide('otp-modal')
        }
    },
    watch: {
        otpCode() {
            if(this.errorMsg) {
                this.$store.dispatch("otp/setErrorMsg","")
            }
            String.prototype.toHalfWidth = function() {
                return this.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)});
            };
            this.otpCode = this.otpCode.toHalfWidth()
        }
    }
}
</script>
